import anime from 'animejs';
import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';
import cookie from 'js-cookie';
import {
	duration,
	queryFocusable,
	makeCallback,
	trapFocus,
	releaseFocus,
} from './utilities';
import { slideHide } from './animations';

/**
 * Callback stuff
 */

const callbacks = makeCallback<{ value: string; willNavigate: boolean }>();
const immediateCallbacks = makeCallback<{
	value: string;
	willNavigate: boolean;
}>();

const onSetPreference = callbacks.add;
const onSetPreferenceImmediate = immediateCallbacks.add;
export { onSetPreference, onSetPreferenceImmediate };

window.addEventListener('DOMContentLoaded', () => {
	const el = document.querySelector<HTMLElement>('[data-alcohol-preference]');
	const content = el?.querySelector('.age-check__content');

	const preference = cookie.get('alcohol_preference');

	if (!el || typeof preference !== 'undefined') {
		immediateCallbacks.invoke({ value: preference || '', willNavigate: false });
		callbacks.invoke({ value: preference || '', willNavigate: false });
		el?.parentElement?.removeChild(el);
	}

	/**
	 * Set up the age check
	 */
	if (el) {
		disableBodyScroll(el);
		trapFocus(el);
	}

	const setPreference = (value: string, url: string | null, close: boolean) => {
		const attrs: cookie.CookieAttributes = {
			path: '/',
			expires: 30,
		};

		cookie.set('alcohol_preference', value, attrs);
		immediateCallbacks.invoke({ value, willNavigate: !!url });

		const timeline = anime.timeline({
			easing: 'cubicBezier(.6,.02,.92,.73)',
			complete() {
				if (el) {
					releaseFocus(el);
					enableBodyScroll(el);
					el.parentNode?.removeChild(el);
				}
			},
		});

		timeline.add(
			{
				targets: content,
				opacity: 0,
				duration: duration(400),
				scale: 0.85,
			},
			0,
		);

		timeline.add(
			{
				targets: el,
				opacity: 0,
				duration: duration(400),
			},
			250,
		);

		window.setTimeout(() => {
			callbacks.invoke({ value, willNavigate: !!url });
		}, 500);

		if (url) {
			setTimeout(() => {
				window.location.href = url;
			}, duration(400));
		} else if (close) {
			const inPageElement = document.querySelector<HTMLElement>(
				'[data-alcohol-preference-in-page]',
			);
			if (inPageElement) {
				slideHide(inPageElement);
			}
		}
	};

	const actions = document.querySelectorAll<HTMLElement>(
		'[data-alcohol-preference-set]',
	);
	actions.forEach((action) => {
		action.addEventListener('click', () => {
			const preference = action.getAttribute('data-alcohol-preference-set');
			const url = action.getAttribute('data-alcohol-preference-url');
			const closeAttr = action.getAttribute('data-alcohol-preference-close');
			const close = closeAttr !== null && closeAttr !== 'false';
			if (!preference) return;

			setPreference(preference, url, close);
		});
	});
});
